
<!-- 上传资源页面 -->
 <template>
  <div class="app">
    <div class="divCard">
      <el-card shadow="always" style="width: 814px">
        <!-- 使用table标签布局 -->
        <table>
          <!-- 第一行，标题 -->
          <tr>
            <th colspan="2">
              <div style="text-align: center">上传资源</div>
            </th>
          </tr>

          <!-- 第二行，上传资源
           1.:on-success= "handleFileUpload"这里不需要传递参数，下面的方法带就可以
          -->
          <tr>
            <td colspan="2">
              <div id="divUpload">
                <el-upload
                  class="upload-demo"
                  drag
                  :action="baseUrl+'/file/uploadResourceFile'"
                  multiple
                  :data="uploadData"
                  :on-success="handleFileUpload"
                  :on-remove="handleFileRemove"
                >
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">
                    将文件拖到此处，或<em>点击上传</em>
                  </div>
                </el-upload>
              </div>
            </td>
          </tr>

          <!-- 第三行，form表单 -->
          <tr>
            <td>
              <el-form
                :model="resourceDataRequest"
                :rules="rules"
                ref="resourceDataRequest"
                label-width="100px"
                class="demo-ruleForm"
              >
                <!-- 资源名称 -->
                <el-form-item label="资源名称" prop="resourceName">
                  <el-input
                    type="textarea"
                    v-model="resourceDataRequest.resourceName"
                  ></el-input>
                </el-form-item>

                <!-- 资源描述 -->
                <el-form-item label="资源描述">
                  <el-input
                    type="textarea"
                    v-model="resourceDataRequest.resourceDescription"
                    :autosize="{ minRows: 9 }"
                  ></el-input>
                </el-form-item>

                <!-- 资源标签 -->
                <el-form-item label="资源标签" prop="resourceTab">
                  <el-tag
                    :key="tag"
                    v-for="tag in dynamicTags"
                    closable
                    :disable-transitions="false"
                    @close="handleClose(tag)"
                  >
                    {{ tag }}
                  </el-tag>
                  <el-input
                    class="input-new-tag"
                    v-if="inputVisible"
                    v-model="inputValue"
                    ref="saveTagInput"
                    size="small"
                    @keyup.enter.native="handleInputConfirm"
                    @blur="handleInputConfirm"
                  >
                  </el-input>
                  <el-button
                    v-else
                    class="button-new-tag"
                    size="small"
                    @click="showInput"
                    >+ New Tag</el-button
                  >
                </el-form-item>

                <!-- 所属分离 -->
                <el-form-item label="所属分类">
                  <el-select
                    v-model="resourceDataRequest.resourceType"
                    placeholder="请选择"
                  >
                    <el-option label="面试题库" value=0></el-option>
                    <el-option label="精品文章" value=1></el-option>
                    <el-option label="精品项目" value=2></el-option>
                    <el-option label="资源下载" value=3></el-option>
                  </el-select>
                </el-form-item>

                <!-- 可见范围 -->
                <el-form-item label="可见范围">
                  <el-radio-group
                    v-model="resourceDataRequest.visibility"
                    @input="changeRadio"
                  >
                    <el-radio label="public">全部可见</el-radio>
                    <el-radio label="private">仅我可见</el-radio>
                    <el-radio label="pointsRequired">积分购买</el-radio>
                  </el-radio-group>
                  <!-- 积分输入框 -->
                  <span id="spanNumber">
                    <el-input-number
                      v-model="resourceDataRequest.price"
                      :disabled="inputNumberStatu"
                      :precision="2"
                      :step="0.1"
                      size="mini"
                      controls-position="right"
                      style="margin-left: 10px"
                    ></el-input-number>
                  </span>
                </el-form-item>
              </el-form>
            </td>
          </tr>

          <!-- 提交按钮 -->
          <tr>
            <td class="tdbut1">
              <el-button class="elbut1" type="danger" round
               @click="resourceSubmit" ><b>提交</b></el-button
              >
            </td>
          </tr>
        </table>
      </el-card>
    </div>
  </div>
</template>
 
 <script>
//  导入接口调用
import { deleteFile,resourceAdd } from "@/api/resourceDownLoad/resourceDownLoad.js";
export default {
  data() {
    return {
      // 设置校验规则
      rules: {
        // 资源名称校验规则
        resourceName: [
          { required: true, message: "请输入资源名称", trigger: "blur" },
          { min: 3, message: "长度大于3个字符", trigger: "blur" },
        ],
      },

      //   请求参数
      resourceDataRequest: {},

      //   资源标签数据
      dynamicTags: [],
      inputVisible: false,
      inputValue: "",

      // 积分输入框是否禁用
      inputNumberStatu: true,

      // 文件上传地址
      fileUrl:"",

      // 上传的请求参数
      uploadData:{}
    };
  },

  created () {
    this.getUserName();
  },

  methods: {

    // 获取当前登录用户
    getUserName() {
      const userData = JSON.parse(localStorage.getItem("accessUserData"));
      this.uploadData.userName = userData.data.userName;
    },

    // 资源标签方法
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.dynamicTags.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = "";
    },

    // 可见范围单选按钮绑定值改变时执行
    changeRadio() {
      // 进行判断，如果为3，则积分输入框设置为false
      if (this.resourceDataRequest.visibility === "pointsRequired") {
        this.inputNumberStatu = false;
      } else {
        this.inputNumberStatu = true;
      }
    },

    // 文件上传成功后调用,返回的值，文件数据，文件列表数据
    handleFileUpload(response, file, fileList) {
      console.log("文件上传获取的响应数据：" + JSON.stringify(response));
      console.log("文件上传获取文件列表数据：" + JSON.stringify(fileList));
      // 设置文件上传地址
      this.fileUrl=response.data;
    },

    //  文件列表移除文件时的钩子
    async handleFileRemove(file, fileList) {
      console.log("文件被移除：" + JSON.stringify(file));
      const res = await deleteFile(file.response.data,this.uploadData.userName);
      console.log("删除成功：" + JSON.stringify(res));
    },

    // 资源上传提交
    async resourceSubmit(){
      console.log('进入资源提交方法');
      // 对没有的数据进行封装
      // 获取当前用户id
      const userData= JSON.parse(localStorage.getItem('accessUserData')); 
      this.resourceDataRequest.userId=userData.data.userId;
      // 封装资源标签
      this.resourceDataRequest.dynamicTags=this.dynamicTags;
      // 封装文件上传url
      this.resourceDataRequest.fileUrl=this.fileUrl;
      console.log("上传资源的请求数据为："+JSON.stringify(this.resourceDataRequest));
      const res= await resourceAdd(this.resourceDataRequest);

      // 判断相应码
      if(res.status==='200'){
         this.$message({
          showClose: true,
          message: '添加成功',
          type: 'success'
        });

        // 跳转到资源首页
      this.$router.push('/resourceDownload');
      };

    }
  },

  // 计算属性
  computed: {
    baseUrl() {
      // 获取main.js中定义的公共参数地址
      return this.$baseUrl;
    },
  },
};
</script>
 
 <style scoped>
.app {
}
/* 卡片标签外围样式 */
.divCard {
  display: flex;
  justify-content: center;
}

/* table内容标题样式 */
table {
  width: 100%;
  border-collapse: collapse;
}
th,
td {
  /* border: 1px solid #000; */
  padding: 8px;
  text-align: left;
}

/* 文件上传样式 */
#divUpload {
  display: flex;
  justify-content: center;
}

/* 资源标签样式 */
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}

/* 提交按钮的样式 */
.tdbut1 {
  display: flex;
  flex-direction: row; /* 主轴方向是行 */
  justify-content: space-around; /* 在主轴上均匀分布子项 */
  align-items: center; /* 在交叉轴上居中对齐子项 */
}
.elbut1 {
  text-align: center;
  width: 140px;
}
</style>